import { useQuery } from '@tanstack/react-query';
import { getPharmDashboardService } from '../../../domains/pharmDashboard';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

export const useRecommendationHits = (
  brn: string | null | undefined,
  range: 'day' | 'week' | 'month' = 'week'
) => {
  return useQuery({
    queryKey: ['recommendation-hits', brn, range],
    enabled: !!brn,
    queryFn: async () => {
      const res = await getPharmDashboardService().getRecommendationHits(brn, { range });
      if (!isResultOk(res)) return null;
      return res?.data ?? null;
    },
  });
};
